<template>
  <div class="login-page">
	  <a-row class="login-row">
		<a-col :xs="24" :sm="24" :md="24" :lg="15" :xl="15" class="login-lr login-leftbk">
			<div class="system-box">
				<img class="logo" src="@/assets/img/login/login-logo.png" alt="" />
				<div class="system-name" :title="'防汛通'" :data-w="screenWidth">防汛通</div> 
			</div>
		</a-col>
		<a-col :xs="24" :sm="24" :md="24" :lg="9" :xl="9" class="login-from">
		  
		  <div class="login-box">
		    <div class="login">
		      <div class="title">欢迎登录</div>
		      <div class="sub-title">
				  <template v-for="(item,index) in ltype">
					  <span :key="index" v-if="item.is==0" @click="changLoginType(item.id)">{{item.title}}</span>
					  <span :key="index" v-else class="active" @click="changLoginType(item.id)">{{item.title}}</span>
				  </template>
				  
			  </div>
			  <template v-if="ltypeVal==2 ">
				  
				  <a-input
				    ref="userNameInput"
				    v-model="userName"
				    placeholder="请输入账号"
				    class="login-user"
				    size="large"
				  >
				    <a-icon
				      style="font-size: 24px; color: #979899"
				      slot="prefix"
				      type="user"
				    />
				  </a-input>
				  <a-input-password 
					ref="userNameInput"
					v-model="password"
					placeholder="请输入密码"
					class="login-user login-password"
					size="large"
				  >
					<img
					  style="width: 24px; height: 24x"
					  src="@/assets/img/login/key.png"
					  slot="prefix"
					/>
				  </a-input-password>				  
			  </template>
			  <template v-if="ltypeVal==1 ">
				  
				  <a-input
				    ref="userTelInput"
				    v-model="userTel"
				    placeholder="请输入手机号"
				    class="login-user"
				    size="large"
				  >
				    <a-icon
				      style="font-size: 24px; color: #979899"
				      slot="prefix"
				      type="user"
				    />
				  </a-input>
				  <a-row>
					  <a-col :span="16">
						  <a-input
							ref="userNameInput"
							v-model="dxpassword"
							placeholder="请输入短信验证码"
							class="login-user login-password login-password2"
							size="large"
							>
								<img
								  style="width: 24px; height: 24x"
								  src="@/assets/img/login/key.png"
								  slot="prefix"
								/>
						  </a-input>		
					  </a-col>
					  <a-col :span="8" style="text-align: right;">	
							<a-button class="dxbtn">获取验证码</a-button>
					  </a-col>
				  </a-row>		  
			  </template>
			  
		      <div @click="handleLogin" class="login-btn flex-box">登录</div>
		      <a-checkbox @change="onChange" v-model="nextlogin" class="nextlogin" style="display: none;"> 下次自动登录 </a-checkbox>
		    </div> 
		  </div>
		  
		</a-col>
	  </a-row>
  </div> 
</template>

<script>
import { mapActions } from 'vuex';
export default {
  data() {
    return {		
      userName: '',
      password: '',
	  userTel:"",
	  dxpassword:"",
	  
	  nextlogin:false,
	  token:"",
	  screenWidth: window.innerWidth,
	  rootWidth:0,
	  rem:0,
	  
	  ltypeVal:2,
	  ltype:[
		  {id:1,title:"验证码登录",is:0},
		  {id:2,title:"账号密码登录",is:1}
	  ]
    };
  },
  components: {},
  computed: {
  	  nextloginVal() {
  		var _self=this;
  		_self.nextlogin=_self.$store.state.user.nextlogin;
  		_self.token=_self.$store.state.user.token;
		console.log("nextlogin:",_self.nextlogin);
		
  	    return _self.nextlogin;
  	  }
  },
  watch:{  
	  nextloginVal(newVal) {
		  this.nextlogin=newVal;
	  },
  },
  created() {
	var _self=this;	
	console.log("nextlogin--created:",_self.nextlogin);
	if(_self.nextlogin==true && _self.token!="")
	{
		console.log("token:",_self.token);
		this.$router.push('/main');
		return;
	}
	
	let rootHtml = document.documentElement;
	//限制展现页面的最小宽度
	_self.rootWidth =rootHtml.clientWidth;
	_self.setRootFontSize();
  },
  mounted() {
	  window.addEventListener('resize', this.handleResize);
	  console.log("screenWidth:",this.screenWidth);
  },
  methods: {
     ...mapActions(['Login','SetNextLogin']),
    
    handleLogin() {
          //this.$router.push('/main');
		  //表单验证
		  if (!this.userName || !this.password) {
			this.$message.error('请输入用户名和密码');
			return;
		  }
		  
		  const userInfo = {
			account: this.userName,
			password: this.password
		  };
		  
		  // 调用登录 action
		  this.Login(userInfo)
			.then(response => {
			  this.$message.success('登录成功');
			  this.$router.push('/main');
			})
			.catch(error => {
			  this.$message.error(error || '登录失败');
			});
    },
    
    onChange(e) {
      console.log(`下次自动登录: ${e.target.checked}`);
	  this.SetNextLogin(e.target.checked);
	  //this.$store.dispatch("user/SetNextLogin",e.target.checked);
    },
	handleResize() {
	  this.screenWidth = window.innerWidth;
	  this.$store.commit("setScreenWidth",this.screenWidth);
	},
	setRootFontSize() {
		let rem, rootWidth;
		let rootHtml = document.documentElement;
		//限制展现页面的最小宽度
		rootWidth = rootHtml.clientWidth < 1280 ? 1280 : rootHtml.clientWidth;
		rem = rootWidth / 10;//19.2
		if(rootHtml.clientWidth==1280 )
		{
			rem = rootHtml.clientWidth / 10;
		}
		else{
			if(rootHtml.clientWidth>1280)
			{
				rem=128;
			}		
			else{
				rem = rootHtml.clientWidth / 10;
			}
		}
		this.rem=rem;
	},
	changLoginType(id){
		var ltype=this.ltype;
		for(var i=0;i<ltype.length;i++)
		{
			ltype[i].is=0;
			if(ltype[i].id==id)
			{
				ltype[i].is=1;
				this.ltypeVal=id;
			}
		}
		this.ltype=ltype;
	}
	
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  },
  
};
</script>

<style lang="scss" scoped>
.login-page {
  width: 100%;
  height: 100vh; background-color: #fff;
  .login-bg {
    // width: 762px;
    flex: 6;
    height: 100%;
    object-fit: cover;
  }
  .login-row{ height: 100%;}
  .login-row .login-lr{ height: 100%; width: 762px;}
  .login-leftbk{
	  background-image: url("/assets/img/login/login-bg.png");
	  background-size:cover;
	  background-repeat: no-repeat;
  }
  .login-box {
    flex: 4;
    height: 100%;
    background: #fff;
	width:342px;height: 390px; 
	margin-top: 225px; margin-left: 76px;
    .login {
      display: flex;
      flex-direction: column;
      .title {
        font-size: 36px;
        line-height: 28px;
        font-weight: 600; 
        color: #191a1a;
        margin-bottom: 33px;
      }
      .sub-title {
        color:rgba(151, 152, 153, 1);
        font-size: 16px;
        line-height: 24px;
        font-weight: 600;
        margin-bottom: 25px;
		span{ margin-right:20px;}
		.active{			
			color: #1f6eee;
		}
      }
      .login-user {
        max-width: 342px;
        margin-bottom: 20px;
      }
      ::v-deep .ant-input {
        height: 56px;
        background-color: #f0f4fa;
        border: 1px solid #dce0e6;
        border-radius: 12px;
        padding: 16px 16px 16px 40px;
      }
      ::v-deep .ant-input::placeholder {
        color: #979899;
        font-size: 16px;
        line-height: 24px;
        font-weight: 400;
      }
      ::v-deep .ant-input:focus {
        box-shadow: none;
      }
      .login-password {
        margin-bottom: 48px;
      }
      .login-btn {
        max-width: 342px;
        height: 56px;
        color: #fff;
        font-size: 20px;
        line-height: 28px;
        font-weight: 400;
        font-family: Source Han Sans CN;
        background-image: linear-gradient(
          to right,
          #71a3f3 0%,
          #4e8cf1 50%,
          #2a75ef 100%
        );
        border-radius: 12px;
        justify-content: center;
        margin-bottom: 20px;
      }
	  .dxbtn{height: 56px; border-radius: 12px;}
	  
	  .nextlogin{  }
    }
  }
  .system-box {
    position: relative;
    gap: 7px;
    top: 58px; 
	width: 100%; height: 52px;
    .logo {
      width: 52px;
      height: 52px; 
	  display:block;
	  margin-left: 45px; 
	  margin-right: 7px; 
	  float: left;
    }
    .system-name {
	  float: left;
      color: #0b3773;
      font-size: 36px;
      line-height:52px;
      font-weight: 600;  
    }
  }
}
.flex-box {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width:429px)
{  
	.login-page { 
		height:100vh;
	  .login-row{ height: 100%;}
	  .login-row .login-lr{ height:100%;} 
	  
	  .login-from{ position: absolute;z-index: 2;height: 60%;top: 33.3%; box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);
		  .login-box {
			   padding:35px 36px;
			   .login{
				   .title {
				     font-size: 26px;
				     line-height: 20px; 
				     margin-bottom: 23px;
				   }
				   .sub-title {
				     font-size: 14px;
				     margin-bottom: 25px;
				   }
				   .login-btn { 
				     height: 46px;
					 }
			   }
			}
	  }
		
	.system-box { 
	  top: 53px;  
	  .logo {
		width: 52px;
		height: 52px; display:inline-block; margin-bottom: 15px;
	  }
	  .system-name {
		color: #0b3773;
		font-size: 24px;
		line-height: 20px; 
	  }
	}
	}  
}
@media (max-width:820px)
{  
	.login-page { 
		height:100vh;
	  .login-row{ height: 100%;}
	  .login-row .login-lr{ height:100%;} 
	  
	  .login-from{ position: absolute;z-index: 2;height: 60%;top: 45%; box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.25);background-color: #fff;
		  .login-box {
			   padding:80px 36px;
			   width: 80%; margin: 0px auto;
			    
				.login-user,.login-btn{max-width: 100%;}
			}
	  }
		
	.system-box { 
	  top: 150px;  
	  .logo {
		width: 120px;
		height: 120px; display:inline-block; margin-bottom: 30px;
	  }
	  .system-name {
		color: #0b3773;
		font-size: 40px;
		line-height: 50px; 
	  }
	}
  }  
} 
</style>
<style>
	.login .ant-checkbox-input{width: 24px; height: 24px;}
	.login .ant-checkbox-inner{width: 24px; height: 24px;}
	.login .ant-checkbox-checked .ant-checkbox-inner::after{ margin-left: 2px;}
	.login .ant-checkbox + span{ padding-left: 7px;color: rgba(25, 26, 26, 1);  font-weight: 400;}
</style>